import $ from 'jquery'
import Backbone from 'backbone'
import template from './metric-updates.hbs'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import conductor from 'scoreboard/components/conductor'
import calendars from 'scoreboard/components/calendars'
import config from 'scoreboard/components/config'
import NotesDialog from 'scoreboard/notes/notes-dialog'
import ScorecardNode from 'scoreboard/scorecards/scorecard-node'
import appDisplay from 'scoreboard/components/app-display'
import visible from 'scoreboard/scorecards/visible'
import constants from 'scoreboard/components/constants'
import InfiniteScroller from 'scoreboard/components/infinite-scroller'
import LoadingDots from 'scoreboard/components/loading-dots'
import HeaderControlsPositioner from 'scoreboard/components/header-controls-positioner'
import MetricUpdatesRequester from './metric-updates-requester'
import icon from 'scoreboard/components/icon'
import MarkedField from 'scoreboard/components/marked-field'
import numericValidator from 'scoreboard/components/validators/numeric-validator'
import numericEvaluator from 'scoreboard/components/evaluators/numeric-evaluator'
import DisplayHeader from 'scoreboard/components/display-header'
import FormView from 'scoreboard/components/form-view'
import PeriodDisplay from 'scoreboard/components/period-display'
import selects from 'scoreboard/components/selects'
import MetricUpdatesEmptyState from './metric-updates-empty-state'
import noMetricUpdates from '../no-metric-updates.hbs'
import CovertButtonTooltips from 'scoreboard/components/covert-button-tooltips'
import scrollContainer from 'scoreboard/components/scroll-container'
import guard from 'scoreboard/components/unsaved/guard'
import ScoreCache from 'scoreboard/components/score-cache'
import mobile from 'scoreboard/components/mobile'
import formatValue from 'scoreboard/components/format-value'
import ViWizard from 'scoreboard/imports/vi/vi-wizard'
import deviceType from 'scoreboard/components/device-type'
import layoutManager from 'scoreboard/components/layout-manager'
import MetricUpdateFilter from './metric-update-filter'
import Tooltip from 'scoreboard/components/tooltip'
import OnOffToggle from 'scoreboard/components/on-off-toggle'
import center from 'scoreboard/components/min-height-vertical-center-msg.hbs'
import buildMetricTooltip from '../build-metric-tooltip'
import { setupUnapprovedValues, hasUnapprovedValues }
	from 'scoreboard/scorecards/metrics/unapproved-metrics'
import spotlight from 'scoreboard/components/spotlight'
import DataType from 'scoreboard/datasets/model/data-type'
import HomeNav from '../home-nav'
import { isV5 } from 'scoreboard/components/version'
import { getTextVariation, lookup } from 'scoreboard-colors'
const { COLORED_CELL_BG_OPACITY } = constants
const { CURRENCY } = DataType

var ALL_ORGS = -1

function colorBarHtml(color) {
	return '<span class="color-bar ' + color + '"></span>'
}

function valueStr(v) {
	return _.isUndefined(v) || v == null ? '' : v
}

function valueHtml(cssClass, value, metric, round) {
	let scoringType = config.scoringType(metric.scoringTypeId)
	let yesNo = constants.YES_NO == _.get(scoringType, 'standardScoringType')
	if (yesNo || scoringType.isCustomText) {
		var noSelectedHtml = value === false ? ' selected' : ''
		var yesSelectedHtml = value === true ? ' selected' : ''
		let optionsHtml = ''
		if (yesNo) {
			optionsHtml =
				'<option value="true"' + yesSelectedHtml + '>' + _.escape(i18n.get('common.yes')) + '</option>' +
				'<option value="false"' + noSelectedHtml + '>' + _.escape(i18n.get('common.no')) + '</option>'
		} else {
			_.each(scoringType.thresholds, threshold => {
				let selected = value == threshold.id ? ' selected' : ''
				optionsHtml +=
					`<option value="${threshold.id}"${selected}>` +
						_.escape(i18n.get(threshold.label)) +
					'</option>'
			})
		}
		return '<span class="metric-update-input full-width">' +
			'<select class="' + cssClass + '">' +
			'<option></option>' +
			optionsHtml +
			'</select>' +
		'</span>'
	}

	if (scoringType.isCustomText) {
		return `<span `
	}

	if (round) {
		let precision = metric.precision
		if (_.isUndefined(precision)) {
			precision = metric.dataType === CURRENCY ?
				config.defaultCurrencyPrecision : config.defaultPrecision
		}
		// Must only adjust precision. Grouping symbols will break marked-field formatting (#17474)
		value = formatValue({value, precision, shorten: false, group: false})
	}
	return '<span class="metric-update-input"><input class="' + cssClass + '" type="text" value="' + valueStr(value) + '"></span>'
}

/**
 * A private method which toggles the applicable styling of the row.
 */
var toggleApplicable = function(row, applicable) {
	row.toggleClass('not-applicable', !applicable)
	if (!applicable) {
		const actualEl = row.find('.actual-cell .marked-field')
		const actualMarkedField = actualEl.find('input, select').data('view')
		_.invoke(actualMarkedField, 'removeTooltip')
	}
}

var MetricUpdates = Backbone.View.extend({

	tagName: 'form',
	className: 'home metric-updates table-hack display-layout scroll-layout-xy',

	// keeps track of updated data that should be used instead of the data
	// in the original stream
	_updated: null,
	// The requester instance used to stream results
	requester: null,

	events: {
		'click tbody td:first-child a': 'overview',
		'click .icon-note': 'notes',
		'click .reset-all': 'resetAll',
		'change [name=applicable]': 'onChangeApplicable',
		'click .import': 'onClickImport',
		'click .panel-header .filter': '_filter'
	},

	initialize: function(options = {}) {
		this.options = options

		// *************************
		// State used for rendering
		// *************************

		// All Organizations is the default value in the org selector
		this._selectedOrgId = ALL_ORGS
		// Metrics have to be rendered in batches while more data is streaming in
		// this array keeps them in order and they are removed from the front
		this._metricRenderQueue = []
		// Whether or not the data is fully loaded for the selected org
		this._done = false
		// the the last Org ID that had a row added to the table
		this.lastOrgId = null

		// *************************
		// View Components
		// *************************

		this.markedFields = []

		this.formView = new FormView({
			el: this.el,
			toggleCancel: true,
			submit: this.submit.bind(this)
		})
		this.formView.on('change', this._change.bind(this))

		this.periodDisplay = new PeriodDisplay({ guard: true })

		this.markerWidths = {}

		// holds all scores that have been received from the server
		this.scoreCache = new ScoreCache()
	},

	render: function() {
		this.$el.empty().append(new DisplayHeader({
			heading: i18n.get('home.metricUpdates'),
			mobileGearHidden: true
		}).render().el, template({
			noMetricsForPeriodMsg: center(i18n.get('scorecards.node.metric.emptyPeriod'))
		}))

		this.renderHomeNav(this.$('.home-nav-container'))

		// Loading dots used during the initial page load. These occur outside the .panel.
		this.initialLoadingDots = new LoadingDots({ el: this.$('.initial-loading-dots-container') })
		// Loading dots used while awaiting data after the .panel is already visible (ex. while changing period).
		this.loadingDots = new LoadingDots({ el: this.$('.loading-dots-container') })

		this.$('.table-hack-row').addClass('is-not-visible')
		this.initialLoadingDots.render()
		this.$('.period-display').append(this.periodDisplay.el)
		this.periodDisplay.render()

		this._toggleLoadingDots(true)

		this.covertButtonTooltips = new CovertButtonTooltips({ el: this.el })

		// Detect when the .forward/.backward buttons are clicked on the periodDisplay.
		// We'll use this to determine whether or not a period change was performed using one
		// of those buttons so we'll know how to properly adjust the header elements in
		// this._adjustForHeaderElements()
		this.periodDisplay.$('.forward').click(() => this.periodForward = true)
		this.periodDisplay.$('.backward').click(() => this.periodBackward = true)
		this.periodDisplay.on('change:period', () => {
			this._toggleLoadingDots(true)
			// If we're in the mobile orientation, the head + nav panes aren't visible
			// so no need to correct the clientX coordinate
			if (mobile.isMobileOrientation()) {
				this.periodButtonClickOffset = e.clientX
				return
			}

			let headWidth = layoutManager.isHeadCollapsed() ? constants.HEAD_PANE_COLLAPSED_WIDTH : layoutManager.headPane.width()
			let navWidth = layoutManager.isNavCollapsed() ? 0 : layoutManager.navPane.width()
			this.periodButtonClickOffset = e.clientX - (headWidth + navWidth)
		})

		this._adjustForHeaderElements()
		this.$('.not-applicable-header').toggleClass('is-not-displayed', !config.showNaOption)
		this.toggles = []

		return this
	},

	orgs: function(orgs) {
		orgs = _.sortBy(orgs, function(org) {
			return org.label.toUpperCase()
		})
		orgs.unshift({
			label: i18n.get('report.common.optionList.organizations.all'),
			id: ALL_ORGS
		})
		this.allOrgs = orgs
		this.orgsById = _.keyBy(orgs, 'id')
	},

	periods: function(periods) {
		this.periods = periods
	},

	updatesAnyMetric: function(updatesAnyMetric) {
		this.updatesAnyMetric = updatesAnyMetric
	},

	/**
	 * callback executed when a new stream of metrics should be displayed
	 * @param {Chunker} stream
	 */
	stream: function(stream) {
		this._clear()
		// #49871 #49769 need to clear out any listeners on the old stream
		// (if it exists) before we start working with the new one
		this._clearOldStream()

		this._metrics = []
		this._metricsById = {}
		this._stream = stream
		// once a new metric stream is available and streams the first new metric
		stream.once('data', this._clear.bind(this))
		stream.on('data', metrics => this._onData(metrics))
		stream.on('end', metrics => this._onData(metrics, true))
		this._toggleLoadingDots(true)

		if (_.isNil(this.scroller)) {
			this._initScroller()
		}

		// Keep a reference to the 'scroll' event listener so we can manually
		// remove it later in _clearOldStream()
		this._streamOnScroll = stream.next.bind(stream)
		this.scroller.on('scroll', this._streamOnScroll)

		stream.on('data', this.scroller.dataReady.bind(this.scroller))
		this.on('resize', () => this._adjustForHeaderElements())
	},

	_initScroller: function() {
		let elScrollContainer = scrollContainer(this.el)
		this.scroller = new InfiniteScroller({ el: elScrollContainer })
		this.scroller.on('scroll:end', () => this._adjustForHeaderElements())
		this.controlsPositioner = new HeaderControlsPositioner({
			positionedElement: this.$('.right-options'),
			scrollElement: this.$('table'),
			scrollContainer: elScrollContainer,
			top: 3
		})
	},

	_clear: function() {
		this.lastOrgId = null
		this._metricRenderQueue = []
		this._metricsInOrg = []
		this._done = false
		this._toggleIsResizing(true)
		// Clear out the table but maintain the width of the .panel. Keeping the width
		// of the panel consistent cuts down on the flickering that happens when you
		// are changing periods. This min-width will get nixed in _adjustForHeaderElements
		this.$('.panel').css('min-width', this.$('.panel').outerWidth())
		this.$('tbody').empty()
	},

	_clearOldStream: function () {
		if (this._stream) {
			this._stream.removeAllListeners()
		}
		if (this.scroller && this._streamOnScroll) {
			this.scroller.off('scroll', this._streamOnScroll)
		}
	},

	_onData: function(metrics) {
		this._done = _.isUndefined(metrics)
		this._metrics = this._metrics.concat(metrics || [])
		_.extend(this._metricsById, _.keyBy(metrics, 'id'))

		// #49769 add the scores to the scoreCache before rendering the metrics
		// so that they will be available for the next batch rendered when scrolling
		this.scoreCache.add(_.flatten(_.map(metrics, metric => {
			// #50460 score.scorecardItemId is sometimes null (not sure why), but
			// we know what the id is because it's nested in the scorecard item,
			// so just set it on the score
			_.forEach(metric.scores, s => s.scorecardItemId = metric.id)
			return metric.scores
		})))

		this._interpretMetrics(metrics)
		this._toggleIsResizing(false)
		this._spotlight()
	},

	_spotlight: function() {
		// If navigating from an e-mail link or an in app alert highlight the update
		// the user clicked on (or anytime queryParams are provided)
		const {nodeId, periodId} = this.options
		if (nodeId && periodId) {
			const focusRow = this.$(`tr[data-id=${nodeId}][data-period-id=${periodId}]`)
			spotlight(focusRow)
		}
	},

	_filter: function() {

		this.listFilterView = new MetricUpdateFilter({
			orgs: this.allOrgs,
			orgId: this._selectedOrgId,
			calendarId: this._selectedCalendarId
		})
		this.listenTo(this.listFilterView, 'change', this._onFilter.bind(this))

		this.filterTooltip = new Tooltip({
			attachTo: this.$('.filter'),
			content: this.listFilterView,
			placement: 'below',
			arrow: 'right',
			extraClass: 'filter-tooltip no-max-width'
		}).render()
	},

	_onFilter: function(orgId, calendarId) {
		guard.conditionallyRun(() => {
			this._selectedOrgId = orgId
			this._selectedCalendarId = calendarId
			this._clear()
			this._toggleIsResizing(false)
			this.$('.panel-content').scrollTop(0)
			this._interpretMetrics(this._metrics)
		},
		// reopen the filter unless they chose "cancel"
		() => this._filter(),
		() => this._filter())
	},

	_interpretMetrics: function (metrics) {
		if (this._selectedOrgId > 0) {
			this._processMetricsInOrg(metrics, this._selectedOrgId)
			if (!this._done) {
				this._stream.next()
			}
		} else {
			this._renderMetrics(metrics)
		}
	},

	_processMetricsInOrg: function(metrics, orgId) {
		var newMetricsInOrg = []
		_.each(metrics, function(metric) {
			if (metric.organizationId === orgId) {
				newMetricsInOrg.push(metric)
			} else if (newMetricsInOrg.length > 1) {
				// this means we've read past the selectedOrg
				// (Orgs are sorted/grouped by name)
				this._done = true
				return false
			}
		}.bind(this))
		this._renderMetrics(newMetricsInOrg)
		this._metricsInOrg = this._metricsInOrg.concat(newMetricsInOrg)
	},

	resetAll: function() {
		var metrics = this._metrics
		this._clear()
		this._interpretMetrics(metrics)
		this.$('.button-primary').attr('disabled', true)
		this.$('tbody tr').data('dirty', false)
		_.invokeMap(this.markedFields, 'clearError')
		this._toggleIsResizing(false)
	},

	_markFieldsInRow: function(row, metric) {
		var self = this
		_.each(row.find('input:not(:checkbox)'), function(input, i) {
			// render a marked field even if the user can't interact with it
			// so that we get fancy
			var markedField = new MarkedField({
				el: input,
				dataType: metric.dataType,
				currencyCode: metric.currencyCode,
				validator: numericValidator,
				evaluator: numericEvaluator,
				inputDisplay: 'inline-block',
				lineHeight: constants.INPUT_HEIGHT,
				fieldPadding: 10,
				markWidthCalculator: function(markText, marker) {
					// we're passing the width calculator here which reuses a
					// measurement for a marker if the marker has the same text.
					// This is an huge speed boost and is possible because all of
					// the inputs on this screen are formatted the same.
					if (!self.markerWidths[markText]) {
						self.markerWidths[markText] = marker.outerWidth()
					}
					return self.markerWidths[markText]
				}
			}).render()
			var isActual = $(input).hasClass('actual')
			var canUpdate = metric[isActual ? 'updateActual' : 'updateThresholds']
			var hasEquation = metric.hasEquation[i]
			if (hasEquation || !canUpdate) {
				markedField.disable()
			}
			this.markedFields.push(markedField)
		}.bind(this))
	},

	_handleNARow: function(row, metric) {
		var periodId = row.data('period-id')
		var score = metric.scoresByPeriodId[periodId]
		if (score && !score.unapprovedApplicable) {
			toggleApplicable(row, false)
		}
	},

	// update the metric.scoresByPeriodId to include any updated scores we
	// received after saving
	_updateMetricScores: function(metric) {
		var byPeriodId = this.scoreCache.scoresByPeriodId(metric.id)
		_.extend(metric.scoresByPeriodId, byPeriodId)
	},

	_renderMetric: function(metric) {

		if (this._selectedCalendarId > 0 && metric.calendarId != this._selectedCalendarId) {
			// A calendar filter was applied, and this metric's calendar doesn't match
			return
		}

		var html = ''

		const {id, description, organizationId} = metric
		metric.scoresByPeriodId = _.keyBy(metric.scores, 'periodId')
		this._updateMetricScores(metric)

		if (metric.organizationId != this.lastOrgId) {
			let colspan = config.showNaOption ? 5 : 4
			html += '<tr class="table-body-subheader">' +
				`<td colspan="${colspan}" class="organization">` +
				_.escape(this.orgsById[organizationId].label) +
				'</td></tr>'
			this.lastOrgId = organizationId
		}

		html += this._constructMetricRowHTML(metric)

		const rowsEl = $(html)
		this.$('tbody').append(rowsEl)

		this._markMetricRows(rowsEl, metric)

		// Now that we know if a row is applicable or not, we can add the toggle
		// with it's correct state.
		let applicableCells = rowsEl.find('.applicable-cell')
		if (!_.isEmpty(applicableCells)) {
			applicableCells.each((i, cell) => {
				const el = $(cell)
				let toggle = new OnOffToggle({
					name: 'applicable',
					checked: el.parent().hasClass('not-applicable')
				})
				el.append(toggle.el)
				this.toggles.push(toggle.render())
			})
		}

		buildMetricTooltip(this.el, '[data-metric-id]', description)

		return rowsEl
	},

	/**
	 * Adds markers to each input in each row
	 * @param {object} rows JQuery object for new rows, first row may be an org
	 * @param metric
	 */
	_markMetricRows: function (rows, metric) {
		var self = this
		rows.each(function () {
			var row = $(this)
			// org rows do not have id's
			if (row.data('id')) {
				// add marked-fields BEFORE marking things n/a
				self._markFieldsInRow(row, metric)
				// handle any not-applicable rows
				self._handleNARow(row, metric)
			}
		})
	},

	_constructMetricRowHTML: function (metric) {
		var scoringType = config.scoringType(metric.scoringTypeId)
		var periodIds = this.periods[metric.calendarId]
		var notesByPeriod = _.transform(metric.notePeriodIds, function(result, periodId) {
			result[periodId] = true
		}, {})

		let html = ''
		if (!_.isEmpty(periodIds)) {

			const visiblePeriods = _.filter(periodIds, id => visible(metric, calendars.periodsById[id]))
			const rowContexts = _.map(visiblePeriods, periodId => {
				const score = metric.scoresByPeriodId[periodId] || {}
				const hasApplicableOption = !metric.hasEquation[0] && config.showNaOption
				return {
					periodId,
					period: calendars.periodsById[periodId],
					score,
					color: (score && score.color) ? score.color : 'gray',
					hasNotes: metric.hasGeneralNotes || notesByPeriod[periodId],
					hasApplicableOption
				}
			})
			let totalVisiblePeriods = _.size(visiblePeriods)
			let extraClass = totalVisiblePeriods > 1 ? 'has-multiple-periods' : ''
			html =
				`<tr data-id="${metric.id}" data-period-id="${_.head(visiblePeriods)}">
				<td class="metric ${extraClass}" rowspan="${totalVisiblePeriods}">
				<a class="row-label text-link" data-metric-id="${metric.id}">${_.escape(metric.label)}</a>
				</td>`

			_.each(rowContexts, (rowContext, i) => {
				let { periodId, period, score, color, hasApplicableOption,
					hasNotes } = rowContext

				// #24350 If we have any updated values that haven't been approved yet, replace
				// display a banner and highlight the relevant rows
				setupUnapprovedValues(score)
				const unapprovedValueClass = hasUnapprovedValues(score) ? 'has-unapproved-values' : ''

				if (i > 0) {
					html += `<tr data-id="${metric.id}" data-period-id="${periodId}">`
				}
				let lookupColor = lookup(color).color
				let textVariation = getTextVariation(lookupColor, COLORED_CELL_BG_OPACITY)
				html +=	`<td class="color ${color} ${unapprovedValueClass} ${textVariation} label-on-colored-background">` +
					_.escape(period.label) +
					'</td>'
				if (hasApplicableOption) {
					html +=	`<td class="applicable-cell ${unapprovedValueClass}"></td>`
				} else if (config.showNaOption) {
					// If show N/A option is toggled in admin settings, but the row doesn't
					// have an equation, make sure there is a cell appended so it doesn't
					// break the table.
					html += `<td class="${unapprovedValueClass}"></td>`
				}
				html +=
					`<td class="actual-cell ${unapprovedValueClass}"><div class="actual-content">` +
					valueHtml('actual', score.unapprovedActual, metric, metric.hasEquation[0]) +
					`<span class="na">${i18n.get('scorecards.node.metric.notapplicable')}</span>` +
					'</div></td>'

				var notesMarkup = '<ul class="table-actions"><li><a class="icon-note button button-covert" data-action="' + i18n.get('common.notes') + '">' +
					icon('note', hasNotes ? 'has-notes' : '') +
					'</a></li></ul>'

				// if there are no thresholds
				// #50254 or if this is a custom text scoring type
				if (!scoringType.thresholdNames || scoringType.isCustomText) {
					html += `<td class="thresholds-cell table-actions-cell ${unapprovedValueClass}">${notesMarkup}</td>`
					return true
				}

				var thresholds = score.unapprovedThresholds || []
				// for goal/base and similar metrics with derived thresholds
				if (scoringType.colors.length > scoringType.thresholdNames.length) {
					html += `<td class="thresholds-cell table-actions-cell scored-middle ${unapprovedValueClass}">`
					_.each(scoringType.colors, function(color, i) {
						html +=	colorBarHtml(color)
						if (i < scoringType.thresholdNames.length) {
							html += valueHtml('threshold', thresholds[i], metric, metric.hasEquation[1 + i])
						}
					})
				// for normal metrics with more thresholds than colors
				} else {
					html += `<td class="thresholds-cell table-actions-cell ${unapprovedValueClass}">`
					_.each(scoringType.thresholdNames, function(key, i) {
						html += valueHtml('threshold', thresholds[i], metric, metric.hasEquation[1 + i])
						if (i < scoringType.colors.length) {
							html +=	colorBarHtml(scoringType.colors[i])
						}
					})
				}

				html += notesMarkup + '</td>'
				if (i != _.size(rowContexts) - 1) {
					html += '</tr>'
				}
			})
			html += '</tr>'
		}
		return html
	},

	_renderMetrics: function(metrics) {
		this._toggleLoadingDots(false)
		// fixes #8992 issue 3
		var newMetrics = _.cloneDeep(metrics)
		this._metricRenderQueue = _.isEmpty(this._metricRenderQueue) ? newMetrics
			: this._metricRenderQueue.concat(newMetrics)

		this.$('.table-hack-row').removeClass('is-not-visible')
		this.initialLoadingDots.remove()

		if (_.isEmpty(this._metrics) && _.isEmpty(metrics)) {
			if (this.updatesAnyMetric) {
				this._setDisplayNoMetricsForPeriod(true)
			} else {
				this.metricUpdatesEmptyState = new MetricUpdatesEmptyState({
					heading: i18n.get('home.metricUpdates'),
					body: noMetricUpdates()
				})
				appDisplay.display(this.metricUpdatesEmptyState)
				this.renderHomeNav(this.metricUpdatesEmptyState.$el)
			}
			this._toggleIsResizing(false)
			return
		} else {
			this._setDisplayNoMetricsForPeriod(false)
		}

		this._processMetricBatch(this._selectedOrgId, metrics)

		if (!this._done) {
			this.showUnapprovedValuesBanner(_.flatMap(metrics, m => m.scores))
		}

		this.formView.start()

		// Was this fresh render caused by clicking the .forward/.backward buttons
		// on the .period-display? If so, pass it to _adjustForHeaderElements so
		// we can adjust the .period-display properly.
		if (this.periodForward || this.periodBackward) {
			this._adjustForHeaderElements({
				forward: this.periodForward,
				backward: this.periodBackward
			})

			delete this.periodForward
			delete this.periodBackward
			delete this.periodButtonClickOffset
		} else {
			this.controlsPositioner.setHeaderControlsPosition()
		}

		//make sure we fill the page on the initial request
		this.scroller.checkScroll()
	},

	renderHomeNav: function(container) {
		if (isV5()) {
			return
		}
		this.homeNav = new HomeNav({
			section: 'metric-updates'
		})
		container.prepend(this.homeNav.el)
		this.homeNav.render()
	},

	showUnapprovedValuesBanner: function() {
		this.$('.unapproved-values-banner-row').toggleClass('is-not-displayed',
			!this.$('tbody td.has-unapproved-values').length)
	},

	_setDisplayNoMetricsForPeriod: function(show) {
		this.$('.metric-values-table').toggleClass('is-not-displayed', show)
		this.$el.toggleClass('has-no-metrics', show)
	},

	_toggleLoadingDots: function(visible) {
		if (visible) {
			this.loadingDots.render()
		} else {
			this.loadingDots.clear()
		}
		this.loadingDots.$el.toggleClass('is-not-displayed', !visible)
		this.$('.panel')
			.toggleClass('panel-with-table', !visible)
			.toggleClass('is-loading', visible)
	},

	_toggleIsResizing: function(isResizing) {
		this.$('.panel').toggleClass('is-resizing', isResizing)
	},

	/**
	 * _processMetric is a cpu intensive operation and running all metrics
	 * synchronously will block the event loop for too long.  This function is
	 * used to batch up the rendering of metrics into small sets.
	 *
	 * @param orgId The orgId that was selected when this function was invoked
	 * for the first time.
	 *
	 * @private
	 */
	_processMetricBatch: function(orgId) {
		if (orgId != this._selectedOrgId) {
			console.log('aborting rendering of org: ', orgId, ' for current org: ', this._selectedOrgId)
		} else {
			for (var i = 0; i < 5 && !_.isEmpty(this._metricRenderQueue); i++) {
				var metric = this._metricRenderQueue.shift()
				metric && this._renderMetric(metric)
			}

			if (!_.isEmpty(this._metricRenderQueue)) {
				// This timeout needs to be in place in order to allow the event
				// loop to proceed after 5 metrics.
				setTimeout(() => {
					this._processMetricBatch(orgId)
					this.controlsPositioner.setHeaderControlsPosition() // #27704
				}, 0)
			} else {
				selects(this.$('tbody select'))
			}
		}
	},

	overview: function(e) {
		if (mobile.isTouchMoving() || (config.displayIds && deviceType.touchOnly)) {
			return
		}

		guard.conditionallyRun(() => {
			var id = $(e.target).closest('tr').data('id')
			conductor.overview('scorecards', id)
		})
	},

	onChangeApplicable: function(e) {
		var row = $(e.target).closest('tr')
		toggleApplicable(row, !$(e.target).is(':checked'))
		this._change(e)
		this.formView.change(e)
	},

	notes: function(e) {
		var row = $(e.target).closest('tr')
		var id = row.data('id')
		var periodId = row.data('period-id')
		const model = new ScorecardNode({ id: id })
		const modelPromise = model.fetch({
			data: {
				notes: true,
				calendarPeriodId: periodId
			}
		})
		appDisplay.dialog(modelPromise, () => {
			var notesView = new NotesDialog({
				model,
				defaultTime: periodId,
				timeLabel: calendars.periodsById[periodId].label
			})
			notesView.on('change:notes', (notes) => {
				var notePeriodIds = []
				var hasGeneralNotes = false
				_.each(notes, function(note) {
					if (note.periodId) {
						notePeriodIds.push(note.periodId)
					} else {
						hasGeneralNotes = true
					}
				})
				// must update the model the report is working from in case
				// we change orgs, since changing orgs doesn't issue a new
				// request
				this._metricsById[model.id].notePeriodIds = notePeriodIds
				this._metricsById[model.id].hasGeneralNotes = hasGeneralNotes
				var hasNotes = hasGeneralNotes || _.includes(notePeriodIds, periodId)
				row.find('.icon-note svg').toggleClass('has-notes', hasNotes)
				// Re-evaluate in case previous save failed due to missing note (#16172)
				this.errorOnSave && this.formView.change()
			})
			return notesView
		})
	},

	_change: function(e) {
		e && $(e.target).closest('tr').data('dirty', true)
	},

	_positionSavedOverlay: function(row) {
		var overlay = this.$('.saved-overlay')
		if (overlay.length) {
			var offset = row.find('.actual-cell').outerWidth() +
				row.find('.thresholds-cell').outerWidth()
			overlay.css('right', (offset/2) - overlay.outerWidth()/2)
			// Use offsetHeight instead of outerHeight(), because outerHeight() returns
			// an inaccurate calculation for table cells in IE11.
			overlay.css('padding-top', (row.find('.actual-cell')[0].offsetHeight/2) - overlay[0].offsetHeight/2)
		}
	},

	onClickImport() {
		ViWizard.start({
			type: 'metric-value',
			doneKey: 'admin.import.run'
		})
	},

	submit: function() {
		this.errorOnSave = false
		var scores = []
		_.each(this.$('tbody tr'), function(row) {
			row = $(row)
			if (row.data('dirty')) {
				var metricId = row.data('id')
				var score = this.scoreCache.get(metricId, row.data('period-id'))
				if (_.isNil(score)) {
					score = {
						scorecardItemId: metricId,
						periodId: row.data('period-id')
					}
				}
				score = _.cloneDeep(score)
				scores.push(score)

				// #12350 don't send the server an actual value if the client
				// isn't allowed to update it (b/c of permissions or b/c it's
				// calculated)
				var metric = this._metricsById[metricId]
				if (metric.updateActual && !metric.hasEquation[0]) {
					var select = row.find('select.actual')
					if (select.length > 0) {
						score.unapprovedActual = select.val()
					} else {
						score.unapprovedActual = row.find('input.actual').data('view').val()
					}
				}
				score.unapprovedApplicable = !row.hasClass('not-applicable')
				score.unapprovedThresholds = []
				_.each(row.find('input.threshold'), function(threshold) {
					threshold = $(threshold)
					const val = threshold.data('view').val()
					score.unapprovedThresholds.push(val)
				})
			}
		}.bind(this))

		var requester = new MetricUpdatesRequester()
		var stream = requester.save(scores)

		stream.once('data', () => this.$('tbody tr').data('dirty', false))

		stream.on('data', score => {
			const submitRow = this.$('tr[data-id=' + score.scorecardItemId + '][data-period-id=' + score.periodId + ']')
			submitRow.find('td.color').removeClass().addClass('color ' + score.color)
			submitRow.find('td.thresholds-cell').append('<div class="saved-overlay">' +
				icon('approved','icon-done') +
				i18n.get('common.saved') + '</div>')
			this._positionSavedOverlay(submitRow)
			submitRow.addClass('is-saving')

			// #39270 show the row as pending if the submitted values need approval
			submitRow.find('td:not(.metric)').toggleClass('has-unapproved-values', hasUnapprovedValues(score))
			this.showUnapprovedValuesBanner()

			this.scoreCache.add(score)
		})

		return new Promise((resolve,reject) => {
			// When saving is done, remove the save overlay & reset save button
			stream.on('end', () => {
				// Wait 2 seconds before dismissing the saved overlay or else the animation
				// will appear not to happen upon quick responses from the server
				setTimeout(() => {
					this.$('.is-saving').removeClass('is-saving')
					this.$('.saved-overlay').one('transitionend', e => $(e.target).remove())
				}, 2000)
				this.formView.start()
				this.setFocusAfterSave()
				resolve(requester.xhrStream.xhr)
			})

			stream.on('error', e => {
				this.errorOnSave = true
				this.formView.error(e.xhr)
				reject(e)
			})
		})
	},

	// issue #10138 focus in first field after lowest saved record
	setFocusAfterSave: function() {
		// find the next tr with an enabled input
		var nextRows = $('tr.is-saving').last().nextAll('tr:not(.table-body-subheader)')
		var nextUpdateRow = _.find(nextRows, function (row) {
			return $(row).find('input:enabled')
		})

		// put the focus on the first enabled input in the row
		// (since the actual field could be calculated, for example)
		var nextInput = $(nextUpdateRow).find('input:not(:checkbox):enabled').first()
		nextInput.focus()

		// put the cursor at the end of the text field if possible
		if (nextInput.val()) {
			var endIndex = nextInput.val().length
			if (nextInput[0].setSelectionRange) {
				nextInput[0].setSelectionRange(endIndex, endIndex)
			}
		}
	},

	/**
	 * Adjusts the elements inside the .panel-header as well as the width of the
	 * .panel in order to compensate for the width available in the viewport.
	 * @param  {Object} lockToCursor Appears if we'll need to be adjusting in order to keep the .period-display under the mouse cursor
	 * @param  {Boolean} lockToCursor.forward True if the .period-display.forward buttton was pressed
	 * @param  {Boolean} lockToCursor.backward True if the .period-display.backward buttton was pressed
	 */
	_adjustForHeaderElements: function(lockToCursor) {
		let panel = this.$('.panel')
		let panelHeader = this.$('.panel-header')
		let rightOptions = this.$('.right-options')

		this._toggleIsResizing(true)

		if (_.isNil(this.scroller)) {
			this._initScroller()
		}

		panel.css('min-width', 'auto')

		var resetElements = () => {
			rightOptions.css({
				'left': 'auto',
				'right': 'auto'
			})
		}

		// A scroll or view/window resize has just taken place. Resize the header elements accordingly.
		// Also, if the content is scrolled to the right, the entire view is going to reset back
		// to normal, so we don't need to do any fancy locking to cursor.
		if (_.isNil(lockToCursor) || this.scroller.$el.scrollLeft() > 0) {
			resetElements()
			let filterButtonWidth = this.$('.panel-header h3').outerWidth()
			this.$('.filter-button')
				.css('inset-inline-start', filterButtonWidth + constants.STANDARD_MARGIN/2)
			delete this.periodForward
			delete this.periodBackward
			delete this.periodButtonClickOffset

			this.controlsPositioner.setHeaderControlsPosition()
			this._toggleIsResizing(false)
			return
		}

		// A period increment just took place using the .forward/.backward button. Keep it under the mouse cursor.
		let rightOptionsCorrection = rightOptions.find('a.import').outerWidth() + rightOptions.find('.dropdown').outerWidth()
		let buttonEdgeCorrection = lockToCursor.forward ? 20 : - 5 // adjustments based on the difference in positioning of the .forward/.backward buttons

		// If we need to expand the .panel a bit in order to keep the .period-display under the
		// cursor, do that here.
		if (lockToCursor.forward && panel.outerWidth() < this.periodButtonClickOffset + 20 + 20) { // 20px panel-header padding, 20px distance from .forward to edge of panel
			panel.css('min-width', this.periodButtonClickOffset + 20)
		} else if (lockToCursor.backward && panel.outerWidth() < this.periodButtonClickOffset + 20 + 40) { // 20px panel-header padding, 40px distance from .backward to edge of panel
			panel.css('min-width', this.periodButtonClickOffset + 40)
		}

		rightOptions.css({
			'inset-inline-start': this.periodButtonClickOffset - rightOptionsCorrection - buttonEdgeCorrection - constants.STANDARD_MARGIN - 20 // 20px = .panel-header right+left padding
		})

		this._toggleIsResizing(false)

		// When we mouse out of the .panel-header, things should snap back
		// to the way they naturally should be laid out.
		panelHeader.one('mouseleave', () => this._adjustForHeaderElements())
	},

	remove: function() {
		_.invoke(this.requester, 'abort')
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap(this.markedFields, 'remove')
		_.invokeMap([this.formView, this.periodDisplay, ...this.toggles,
			this.covertButtonTooltips, this.listFilterView, this.filterTooltip],
			'remove')
	}

})


export default MetricUpdates
export { ALL_ORGS }

MetricUpdates.__filename__ = 'home/metric-updates/metric-updates.js'
